import { BehaviorSubject } from 'rxjs';
import SearchMapStore from './SearchMapStore';
import StoreProvider from './StoreProvider';
import isEqual from 'lodash.isequal';
import { longCalculatePromise } from '../../utils/helper';

export type EventDataActive = 'HCODetail' | 'HCPDetail' | 'HCOs' | 'HCPs'
export type EventDataInActive = 'HCODetail-leave' | 'HCPDetail-leave' | 'HCOs-leave' | 'HCPs-leave'

export type EventDataType = EventDataActive | EventDataInActive;

export interface HclSDKEventData {
  currentDisplayType: BehaviorSubject<EventDataType>;
  exitDisplayType: BehaviorSubject<EventDataType>;
  eventData: Record<EventDataType, any>;
}

export const initStateEventStore: HclSDKEventData = {
  currentDisplayType: new BehaviorSubject<EventDataType>(null),
  exitDisplayType: new BehaviorSubject<EventDataType>(null),
  eventData: {} as Record<EventDataType, any>,
};

class EventStore extends StoreProvider<HclSDKEventData> {
  subscriptionStore: SearchMapStore;

  constructor(state: HclSDKEventData, subscriptionStore: SearchMapStore) {
    super(state);
    this.state = state;
    this.subscriptionStore = subscriptionStore;
  }

  get currentEventDisplayType() {
    return this.state.currentDisplayType.getValue()
  }

  get latestExitType() {
    return this.state.exitDisplayType.getValue()
  }

  emitLeaveCurrentDisplayType(eventType: EventDataActive) {
    this.state.exitDisplayType.next(`${eventType}-leave` as EventDataType)
    this.state.eventData[eventType] = this.getValueByEventType(`${eventType}-leave` as EventDataType);
  }

  async emit(eventType: EventDataType) {
    const currentDisplayTypeValue = this.state.currentDisplayType.getValue();

    const valueByEventType = this.getValueByEventType(eventType);

    const latestExitType = this.latestExitType
    const isGobackFromSameType = !!latestExitType && latestExitType.replace('-leave', '') === eventType
    // isEqual might takes long time to process --> longCalculatePromise on simple calculation prevent blocking UI
    // avoid to emit on same event && data not changed
    if (currentDisplayTypeValue !== eventType || (await longCalculatePromise(() => !isEqual(this.state.eventData[eventType], valueByEventType))) || isGobackFromSameType) {
      if (eventType.includes('-leave')){
        this.state.exitDisplayType.next(eventType);
      } else {
        this.state.currentDisplayType.next(eventType);
      }
      this.state.eventData[eventType] = valueByEventType;
      return;
    }
  }

  getValueByEventType(eventType: EventDataType) {
    switch (eventType) {
      case 'HCODetail': {
        return this.getHCODetail();
      }
      case 'HCPDetail': {
        return this.getHCPDetail();
      }
      case 'HCOs': {
        return this.getHCOs();
      }
      case 'HCPs': {
        return this.getHCPs();
      }
      default: {
        return null;
      }
    }
  }

  getHCOs() {
    return this.subscriptionStore.state.hcos;
  }
  getHCPs() {
    return this.subscriptionStore.activities?.data;
  }
  getHCODetail() {
    return this.subscriptionStore.state.hcoDetail;
  }
  getHCPDetail() {
    return this.subscriptionStore.state.individualDetail;
  }
}

export default EventStore;
